module.exports = __webpack_public_path__ + "img/alter-ego-palette_cn.4f99495.jpg";